import React, { FunctionComponent, useLayoutEffect } from "react";
import { makeStyles } from "tss-react/mui";
import Filter from "@/Domains/DispositionManagement/Components/DispositionControls/Elements/Filter/Filter";
import DispositionDateControls from "@/Domains/DispositionManagement/Components/DispositionControls/Elements/DispositionDateControls/DispositionDateControls";
import { Theme } from "@mui/material";
import { useSelector } from "react-redux";
import { selectSidebarIsOpen } from "@/Redux/App/AppReducer";

interface DispositionControlsMainProps {
    contentWidth: number | undefined;
    setHeight: any;
    setPositionTop: any;
}

const useStyles = makeStyles()((theme: Theme) => ({
    dispositionControlsMain: {
        minHeight: "40px",
        position: "fixed",
        zIndex: 410,
        display: "flex",
    },
}));

const DispositionControlsMain: FunctionComponent<
    DispositionControlsMainProps
> = ({ contentWidth, setHeight, setPositionTop }): JSX.Element => {
    const { classes } = useStyles();
    const sidebarIsOpen = useSelector((state) => selectSidebarIsOpen(state));

    useLayoutEffect(() => {
        setHeight(
            document.getElementById("dispo-controls-main")?.clientHeight || 0,
        );
        setPositionTop(
            document.getElementById("dispo-controls-main")?.offsetTop || 0,
        );
    }, [sidebarIsOpen]);

    // TODO
    const dispoControlsPosition = 82;
    if (contentWidth === undefined) {
        contentWidth = 0;
    }

    return (
        <div
            className={classes.dispositionControlsMain}
            id={"dispo-controls-main"}
            style={{ top: dispoControlsPosition, width: contentWidth }}
        >
            <Filter />
            <DispositionDateControls />
        </div>
    );
};

export default React.memo(DispositionControlsMain);
